import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function Costs() {
  const navigate = useNavigate();
  const [costs, setCosts] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCosts();
  }, []);

  async function loadCosts() {
    try {
      const data = await api.getCosts(90);
      setCosts(data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }

  if (loading) return <div className="loading">טוען...</div>;
  if (!costs) return <div className="loading">שגיאה בטעינת נתונים</div>;

  return (
    <>
      <button className="back-btn" onClick={() => navigate('/')}>
        &rarr; חזרה לדשבורד
      </button>

      <div className="page-header">
        <div>
          <div className="page-title">עלויות API</div>
          <div className="page-subtitle">מעקב שימוש ועלויות של כל השירותים</div>
        </div>
      </div>

      <div className="stats-row">
        <div className="stat-card">
          <div className="stat-value blue">${costs.cost_today.toFixed(3)}</div>
          <div className="stat-label">היום</div>
        </div>
        <div className="stat-card">
          <div className="stat-value orange">${costs.cost_this_month.toFixed(3)}</div>
          <div className="stat-label">החודש</div>
        </div>
        <div className="stat-card">
          <div className="stat-value" style={{ color: 'var(--text)' }}>${costs.total_cost.toFixed(3)}</div>
          <div className="stat-label">סה"כ</div>
        </div>
      </div>

      {Object.keys(costs.by_service).length > 0 && (
        <div className="detail-section">
          <div className="detail-section-title">לפי שירות</div>
          {Object.entries(costs.by_service).map(([service, cost]) => (
            <div className="detail-row" key={service}>
              <span className="detail-label">{service}</span>
              <span className="detail-value">${cost.toFixed(4)}</span>
            </div>
          ))}
        </div>
      )}

      <div className="detail-section" style={{ padding: 0, overflow: 'hidden' }}>
        <div className="detail-section-title" style={{ padding: '16px 16px 8px' }}>פעולות אחרונות</div>
        {costs.entries.length === 0 ? (
          <div className="empty-state" style={{ padding: '20px' }}>
            <p>אין פעולות עדיין</p>
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)', background: 'var(--surface-hover)' }}>
                <th style={{ padding: '8px 16px', textAlign: 'right' }}>תאריך</th>
                <th style={{ padding: '8px 12px', textAlign: 'right' }}>שירות</th>
                <th style={{ padding: '8px 12px', textAlign: 'right' }}>פעולה</th>
                <th style={{ padding: '8px 12px', textAlign: 'center' }}>ביטויים</th>
                <th style={{ padding: '8px 12px', textAlign: 'center' }}>עלות</th>
              </tr>
            </thead>
            <tbody>
              {costs.entries.map(e => (
                <tr key={e.id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '8px 16px', fontFamily: "'JetBrains Mono', monospace", fontSize: '12px' }}>
                    {new Date(e.created_at).toLocaleString('he-IL')}
                  </td>
                  <td style={{ padding: '8px 12px' }}>{e.service}</td>
                  <td style={{ padding: '8px 12px', color: 'var(--text-secondary)' }}>{e.action}</td>
                  <td style={{ padding: '8px 12px', textAlign: 'center', fontFamily: "'JetBrains Mono', monospace" }}>
                    {e.keywords_count}
                  </td>
                  <td style={{ padding: '8px 12px', textAlign: 'center', fontFamily: "'JetBrains Mono', monospace", color: 'var(--orange)' }}>
                    ${e.cost.toFixed(4)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
